export default "__VITE_ASSET__CdKPvgs4__"